/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.2
 */

import { FC, ReactNode, SyntheticEvent } from 'react';

import { Link } from 'react-router-dom';

import { isLinkExternal } from '@/main/utils/isLinkExternal';

import { ELinkTarget } from '../ExternalLink/ExternalLink';

interface IRedirectLinkProp {
    children: ReactNode;
    link: string;
    onClick?: (ev: SyntheticEvent) => void;
    target?: ELinkTarget;
}

const RedirectLink: FC<IRedirectLinkProp> = ({ children, link, target = '_self', onClick }) => {
    if (isLinkExternal(link)) {
        return (
            <a href={link} target={target} onClick={onClick}>
                {children}
            </a>
        );
    }
    return (
        <Link target={target} to={link} onClick={onClick}>
            {children}
        </Link>
    );
};

export default RedirectLink;
